export const tryHandle = actionType => ({ type: actionType, payload: { loading: true } });

export const handleResponse = (actionType, data) => {
  return {
    type: actionType,
    payload: { data: data }
  };
};

export const handleError = (actionType, error) => {
  return {
    type: actionType,
    payload: { data: error }
  };
};
